/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SELECTION_TYPE_OPTIONS = 'SELECTION_TYPE_OPTIONS';
export const SELECTED_TYPE = 'SELECTED_TYPE';
export const SELECTED_SEARCH_TYPE = 'SELECTED_SEARCH_TYPE';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const SEARCH_CONTRACT_STATE = 'SEARCH_CONTRACT_STATE';
export const GET_ALL_REBATE_PROGRAMS = 'GET_ALL_REBATE_PROGRAMS';
export const SELECTED_CREATE_PLAN_TYPE = 'SELECTED_CREATE_PLAN_TYPE';
export const GET_CONTRACT_TAB_VALUE = 'GET_CONTRACT_TAB_VALUE';
export const GET_REFERENCES = 'GET_REFERENCES';
export const GET_COVERAGE_TABLE = 'GET_COVERAGE_TABLE';
export const ADD_COVERAGE_DATE = 'ADD_COVERAGE_DATE';
export const MAITAIN_CONTRACT_STATE = 'MAITAIN_CONTRACT_STATE';
export const GET_DISPUTE_SPECIALIST = 'GET_DISPUTE_SPECIALIST';
export const GET_LETTER_SENDER = 'GET_LETTER_SENDER';
export const GET_MARKET_BASKET_NAME = 'GET_MARKET_BASKET_NAME';
export const GET_CONTRACT_CONTACT_TYPE = 'GET_CONTRACT_CONTACT_TYPE';
export const GET_CONTRACT_SEARCH_DATA = 'GET_CONTRACT_SEARCH_DATA';
export const GET_ALL_CONTRACTS_DETAILS = 'GET_ALL_CONTRACTS_DETAILS';
export const GET_QUARTER_FOR_CONTRACT = 'GET_QUARTER_FOR_CONTRACT';
export const GET_CONTRACT_SEQUENCE_NUM = 'GET_CONTRACT_SEQUENCE_NUM';
export const GET_CONTRACT_FROM_COPY_CONTRACT =
  'GET_CONTRACT_FROM_COPY_CONTRACT';
export const GET_DEFAULT_MFG_DATA = 'GET_DEFAULT_MFG_DATA';
export const GET_DEFAULT_RPC_DATA = 'GET_DEFAULT_RPC_DATA';
export const ERROR_SEARCH_CONTRACT = 'ERROR_SEARCH_CONTRACT';
export const ERROR_OTHER_SEARCH_CONTRACT = 'ERROR_OTHER_SEARCH_CONTRACT';
export const ERROR_MAINTAIN_CONTRACT = 'ERROR_MAINTAIN_CONTRACT';
export const GET_MFG_BY_PLAN_REBATE_PROG = 'GET_MFG_BY_PLAN_REBATE_PROG';
export const GET_DRUG_FAMILY_BY_MFG_ID = 'GET_DRUG_FAMILY_BY_MFG_ID';
export const GET_DRUG_FAMILY_TABLE = 'GET_DRUG_FAMILY_TABLE';
export const VALIDATE_CONTRACT = 'VALIDATE_CONTRACT';
export const GET_WRITE_OFF_DATE_CONTRACT = 'GET_WRITE_OFF_DATE_CONTRACT';
export const CREATE_UPDATE_CONTRACT = 'CREATE_UPDATE_CONTRACT';
export const HANDLE_ERROR_MESSAGE_FOR_CONTRACT =
  'HANDLE_ERROR_MESSAGE_FOR_CONTRACT';
export const GET_UNDO_WRITE_OFF_DATE_CONTRACT =
  'GET_UNDO_WRITE_OFF_DATE_CONTRACT';
export const CLEAR_REDUX_CTRCT = 'CLEAR_REDUX_CTRCT';
export const GET_CONTRACT_INFO = 'GET_CONTRACT_INFO';
export const INITIAL_RESPONSE = 'INITIAL_RESPONSE';
export const CELL_CLICK = 'CELL_CLICK';
export const GET_NEW_CONTRACT_SEQUENCE_NUM = 'GET_NEW_CONTRACT_SEQUENCE_NUM';
export const GET_SELECT_CONTRACT_FOR_INVOICE_CONTACT =
  'GET_SELECT_CONTRACT_FOR_INVOICE_CONTACT';
export const GET_SELECT_CONTRACT_FOR_DISPUTE_CONTACT =
  'GET_SELECT_CONTRACT_FOR_DISPUTE_CONTACT';
export const GET_INV_CONTRACT_CONTACT_DETAILS =
  'GET_INV_CONTRACT_CONTACT_DETAILS';
export const GET_DELETE_DRUG_FAMILY_TABLE = 'GET_DELETE_DRUG_FAMILY_TABLE';
export const GET_DELETE_COVERAGE_GAP = 'GET_DELETE_COVERAGE_GAP';
export const GET_LOAD_COVERAGE_TABLE = 'GET_LOAD_COVERAGE_TABLE';
export const GET_COMMON_CONTRACT_DROPDOWN = 'GET_COMMON_CONTRACT_DROPDOWN';
export const GET_DISPUTE_CONTRACT_CONTACT_DETAILS =
  'GET_DISPUTE_CONTRACT_CONTACT_DETAILS';
export const SELECTED_ROW = 'SELECTED_ROW';
export const GET_POPUP_REBATE_PROGRAMS = 'GET_POPUP_REBATE_PROGRAMS';
export const CONTRACT_TAB_DATA = 'CONTRACT_TAB_DATA'